import { mealVouchersAuthApi } from 'app/src/services/welfareportal'

import { DefaultBodyType, http, HttpResponse } from 'msw'

const apiBaseUrl = './buonipasto/auth/api/v1'

const getUserLogin = http.get<object, DefaultBodyType, mealVouchersAuthApi.UserLoginInfo>(apiBaseUrl + '/user/info', async () => {
  const response: mealVouchersAuthApi.UserLoginInfo = {
    accessToken: '2jd83f83fh32hhfhewh3iinne983085',
    userId: 'BNCMRA70A20H501B',
    companyCode: '97103880585',
  }

  await new Promise((resolve) => setTimeout(resolve, 800))

  return HttpResponse.json(response)
})

export const mealvouchersAuthHandlers = [getUserLogin]
